var map = {
	"./core_button.vue": "93b5",
	"./core_buttons.vue": "c308",
	"./core_column.vue": "e5c2",
	"./core_columns.vue": "dfce",
	"./core_embed.vue": "9cef",
	"./core_gallery.vue": "cb2a",
	"./core_heading.vue": "54f8",
	"./core_image.vue": "0fb6",
	"./core_list.vue": "af3e",
	"./core_list_item.vue": "7012",
	"./core_paragraph.vue": "f930",
	"./core_quote.vue": "f480"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a4a";